export default __webpack_public_path__ + "static/media/A3_25.6b9dd812.mp3";